import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from 'redux/selectors';

/**
 * Whether the relationship_strength_ui feature is enabled.
 *
 * - If a specific network is passed, checks only that network's features.
 * - Otherwise checks the user's managing OR allying collections.
 *
 * Mirrors useHasGoogleSyncFeature so intro-paths can gate the strength UI the
 * same way the rest of the app gates google_sync.
 */
export const useHasRelationshipStrengthFeature = ({ network } = {}) => {
  const user = useSelector(userSelector);

  return useMemo(() => {
    if (network) {
      return network.features?.includes('relationship_strength_ui') ?? false;
    }

    const hasInManaging =
      user?.managingCollections?.some((n) => n.features?.includes('relationship_strength_ui')) ?? false;
    const hasInAllying =
      user?.allyingCollections?.some((n) => n.features?.includes('relationship_strength_ui')) ?? false;

    return hasInManaging || hasInAllying;
  }, [network, user?.managingCollections, user?.allyingCollections]);
};
